// @flow

export interface IconOptions {
  icon: string,
  width?: number,
  height?: number
}

export default class Icon {
  icon: string;
  width: number;
  height: number;
  options: IconOptions;

  /**
   * Construct a new icon instance
   */
  constructor(options: IconOptions) {
    if (!options.icon) {
      throw new Error('At least the icon needs to be defined to create one!');
    }

    this.icon = options.icon;
    this.width = options.width || 16;
    this.height = options.height || options.width || 16;
  }

  /**
   * Generate the icon
   */
  generate(): HTMLElement {
    const svg = document.createElement('svg');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttribute('fill', 'currentColor');
    svg.setAttribute('width', this.width);
    svg.setAttribute('height', this.height);
    svg.innerHTML = `
        <use href="#icon-${this.icon}"></use>
    `;

    return svg;
  }
}
